import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

const { carbon, bluegrey } = colorsPalettes;

export const ItemWrapper = styled(FlexRow)<{ isSelected: boolean; isActive: boolean }>`
    padding: 16px 24px 16px 16px;
    align-items: center;
    cursor: pointer;
    justify-content: space-between;
    height: 40px;
    pointer-events: all;

    ${({ isSelected }) =>
        isSelected
            ? css`
                  background-color: ${bluegrey[100]};
                  cursor: default;
              `
            : null}

    ${({ isActive }) =>
        isActive
            ? css`
                  background-color: ${carbon[25]};
              `
            : null}
    
    &:hover {
        background-color: ${carbon[25]};
    }
`;

export const DataWrapper = styled(FlexColumn)`
    gap: 4px;
    margin-left: 16px;
    margin-right: 24px;
`;

export const CheckMark = styled(SWReactIcons)`
    align-self: center;
`;

export const SharedIcon = styled(SWReactIcons)`
    text-align: center;
`;

export const CountryText = styled.div`
    ${setFontVariant("body2", carbon[300])};
`;

export const Name = styled.div`
    ${setFontVariant("subtitle2", carbon[500])};
    margin-right: 8px;
    max-width: 40ch;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;

export const CustomSecondRow = styled(FlexRow)`
    gap: 16px;
    align-items: center;
`;

export const LeftSide = styled(FlexRow)`
    align-items: center;

    & .ItemIcon {
        box-shadow: none;
    }
`;

export const CountryWrapper = styled(FlexRow)`
    align-items: center;
    gap: 8px;
`;

export const StyledStarIcon = styled(SWReactIcons)`
    height: 16px;
    width: 16px;
    & polygon {
        fill: ${colorsPalettes.blue[400]};
    }
`;

export const StartIconWrapper = styled.div`
    display: flex;
    width: 32px;
    height: 32px;
    justify-content: center;
    align-items: center;
`;

export const CheckMarkWrapper = styled(FlexRow)`
    width: 32px;
    height: 32px;
    justify-content: center;
`;
